import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ReactComponent as CircleCheck } from 'assets/svg/circle-check.svg'
import SVGIcon from 'reusableComponents/SVGIcon'
import Modal from 'reusableComponents/Modal'

const StyledModal = styled(Modal)`
  .modal-header {
    border-bottom: 0;
  }
  .modal-footer {
    border-top: 0;
  }
  .modal-body {
    text-align: center;
    font-size: 1.2rem;
  }
  .modal-content {
    border-radius: 10px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`
const StyledIconContainer = styled.div`
  margin: 4px 0 16px;
`

const SuccessModal = ({ message, show, onHide }) => {
  return (
    <StyledModal customClass="success-custom-modal" show={show} onHide={onHide} centered>
      <StyledIconContainer>
        <SVGIcon Icon={CircleCheck} size="s" color="#28a745" />
      </StyledIconContainer>
      <div>{message}</div>
    </StyledModal>
  )
}

SuccessModal.propTypes = {
  message: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}

export default SuccessModal
